import { render } from "./RoomUtilizationChart.vue?vue&type=template&id=8ba00bca&scoped=true"
import script from "./RoomUtilizationChart.vue?vue&type=script&lang=js"
export * from "./RoomUtilizationChart.vue?vue&type=script&lang=js"

import "./RoomUtilizationChart.vue?vue&type=style&index=0&id=8ba00bca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8ba00bca"

export default script